"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCreationRequest = void 0;
var personProfile_1 = require("./personProfile");
var class_transformer_1 = require("class-transformer");
var UserCreationRequest = /** @class */ (function () {
    function UserCreationRequest() {
    }
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "logonName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_transformer_1.Type)(function () { return personProfile_1.PersonProfile; })
    ], UserCreationRequest.prototype, "profile", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "passwordRecoveryAnswer", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "branchId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "languageId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "currencyId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "password", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "timeZoneId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "cultureInfoIdentifier", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "passwordRecoveryQuestionId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "promotionCode", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "bonusAcceptance", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "sendNewsLetterEmail", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "betPin", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "cardNumber", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "phonePin", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "rfidNumber", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "externalIdentifier", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "instantPayment", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "termsAndConditions", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "privacyPolicy", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], UserCreationRequest.prototype, "exatoValidationId", void 0);
    return UserCreationRequest;
}());
exports.UserCreationRequest = UserCreationRequest;
